// extracted by mini-css-extract-plugin
module.exports = {"popoverContent":"policies_breakdown_popoverContent__2TSUP","popover":"policies_breakdown_popover__Q3yU3"};